import React, { useState } from "react";
import { toast } from "sonner";
import { PaperPlaneTilt, WarningCircle } from "@phosphor-icons/react";
import { Switch } from "@/components/ui/switch";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { adminApi, getErrorMessage } from "@/lib/api";
import { fmtDate } from "../assess/parts";

export function AutoSend({ o, onChange }) {
  const a = o.auto_send || {};
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const save = async (enabled) => {
    setBusy(true);
    try { onChange((await adminApi.put("/admin/wi/outlook/auto-send", { enabled })).data); toast.success(enabled ? "Automatic sending is on" : "Automatic sending is off. New emails stay in Drafts"); }
    catch (e) { toast.error(getErrorMessage(e)); } finally { setBusy(false); setAsk(false); }
  };
  const blocked = a.enabled && a.permission && !a.permission.ok;
  return (
    <div className={`border rounded-xl p-4 space-y-2 ${a.enabled ? "border-[#73bf44]/40 bg-[#73bf44]/[0.04]" : "border-neutral-800 bg-black/30"}`} data-testid="wi-auto-send">
      <div className="flex items-center justify-between gap-3">
        <div className="text-sm text-neutral-200 font-semibold flex items-center gap-2"><PaperPlaneTilt size={16} className="text-[#73bf44]" /> Send emails automatically</div>
        <Switch checked={!!a.enabled} disabled={busy} onCheckedChange={(v) => (v ? setAsk(true) : save(false))} data-testid="wi-auto-send-switch" />
      </div>
      <p className="text-xs text-neutral-400" data-testid="wi-auto-send-text">{a.enabled
        ? `On since ${fmtDate(a.since)}. The dealer approval email and the parts request (CC Krystal) are sent from ${o.mailbox} as soon as a claim is approved. If a send fails, the app tries again every 15 minutes (3 tries), then leaves it in Drafts.`
        : "Off. Emails are saved in the warranty@ Drafts folder and someone presses Send in Outlook."}</p>
      {blocked && <p className="text-xs text-amber-300 flex gap-1.5" data-testid="wi-auto-send-blocked"><WarningCircle size={15} className="shrink-0" />{a.permission.reason}. Until then, emails wait in Drafts. Use the IT email below.</p>}
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent className="bg-[#0F0F0F] border-neutral-800 text-neutral-200" data-testid="wi-auto-send-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-white">Send warranty emails automatically?</AlertDialogTitle>
            <AlertDialogDescription className="text-neutral-400">From now on, every approval sends real emails from {o.mailbox} straight away: the approval confirmation to the dealer, and the parts request to the factory with Krystal CC'd. Emails already in Drafts are not sent.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-transparent border-neutral-700 text-neutral-300 hover:bg-neutral-900 hover:text-white" data-testid="wi-auto-send-cancel">Keep as drafts</AlertDialogCancel>
            <AlertDialogAction className="bg-[#73bf44] text-black hover:bg-[#8ad35c]" disabled={busy} onClick={(e) => { e.preventDefault(); save(true); }} data-testid="wi-auto-send-confirm-btn">Turn on</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
